const Z_INDEX = {
  ON_TOP: '6',
  ACTIONS: '5',
  LOADING: '5',
  ETA: '4',
  TIME: '3',
  WARNING: '2',
  VOID: '0',
};

export { Z_INDEX };
